import { useState } from 'react';
import { CATEGORY_GROUPS, CATEGORY_GROUP_ORDER } from '../../../utils/constants';

// Category badge + inline dropdown on the item card. Drafts-Manager model
// (spec 20260713): the operator picks the SUB-category; the optgroup it sits
// under determines the main. Shared subs (Sound Modules, Headphones, …) appear
// under each of their mains — the group clicked is the main that gets stored.
// Option values encode "main||sub" because e.target.value alone can't tell
// which optgroup a duplicated sub name came from.
// Main stays the mandatory field for Quote Ready (no Unknown/Other escape,
// grill 2026-07-07); the sub drives the BP/SP matrix cell, so a legacy
// main-only row shows the main and picking any sub upgrades it.
export default function CategoryPicker({ main, sub, onChange, source }) {
    const [open, setOpen] = useState(false);
    const current = main ? `${main}||${sub || ''}` : '';

    if (open) {
        return (
            <select className="condition-select" autoFocus value={current}
                onClick={e => e.stopPropagation()}
                onBlur={() => setOpen(false)}
                onChange={e => {
                    const v = e.target.value;
                    setOpen(false);
                    if (!v || v === current) return;
                    const [m, s] = v.split('||');
                    onChange(m, s);
                }}>
                {!main && <option value="" disabled>Select category…</option>}
                {main && !sub && <option value={current} disabled>{main} — pick a sub</option>}
                {CATEGORY_GROUP_ORDER.map(g => (
                    <optgroup key={g} label={g}>
                        {CATEGORY_GROUPS[g].map(s => (
                            <option key={`${g}||${s}`} value={`${g}||${s}`}>{s}</option>
                        ))}
                    </optgroup>
                ))}
            </select>
        );
    }
    // A main outside the canonical 11 (vision mislabel, pre-canonicaliser rows)
    // renders in the missing style — it blocks Quote Ready just like no category.
    const invalid = main && !CATEGORY_GROUP_ORDER.includes(main);
    return (
        <>
            <span className={`badge badge-sm editable ${main && !invalid ? 'badge-neutral qa-cat-badge' : 'qa-cat-missing'}`}
                title={invalid
                    ? `"${sub || main}" isn't one of our categories (vision mislabel) — pick the right one; required before Quote Ready`
                    : main
                        ? (sub ? `${main} › ${sub} — click to change` : `${main} — no sub-category; matrix uses a fallback ladder. Click to pick the sub.`)
                        : 'No category — required before Quote Ready'}
                onClick={e => { e.stopPropagation(); setOpen(true); }}>
                {invalid ? `⚠ ${sub || main}` : (sub || main || '⚠ no category')}
            </span>
            {main && source === 'auto' && (
                <span className="badge badge-sm badge-neutral" title="Automatically classified — not yet confirmed by an operator">auto</span>
            )}
        </>
    );
}
